<div appDropdownOverlay appModalContainer class="h-screen w-full" id="main">
  <div appNotificationContainer></div>
  <router-outlet></router-outlet>
</div>
